module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/vision_lv-f2c7359554b32da2a4605bce523242c6.webp";